const CalendarAltIcon = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3 5.7H17.4V3.9C17.4 3.66131 17.3052 3.43239 17.1364 3.2636C16.9676 3.09482 16.7387 3 16.5 3C16.2613 3 16.0324 3.09482 15.8636 3.2636C15.6948 3.43239 15.6 3.66131 15.6 3.9V5.7H8.4V3.9C8.4 3.66131 8.30518 3.43239 8.1364 3.2636C7.96761 3.09482 7.73869 3 7.5 3C7.26131 3 7.03239 3.09482 6.8636 3.2636C6.69482 3.43239 6.6 3.66131 6.6 3.9V5.7H5.7C4.98392 5.7 4.29716 5.98446 3.79081 6.49081C3.28446 6.99716 3 7.68392 3 8.4V9.3H21V8.4C21 7.68392 20.7155 6.99716 20.2092 6.49081C19.7028 5.98446 19.0161 5.7 18.3 5.7Z"
        fill="#FB3973"
      />
      <path
        d="M3 18.3C3 19.0161 3.28446 19.7028 3.79081 20.2092C4.29716 20.7155 4.98392 21 5.7 21H18.3C19.0161 21 19.7028 20.7155 20.2092 20.2092C20.7155 19.7028 21 19.0161 21 18.3V11.1H3V18.3Z"
        fill="#FB3973"
      />
    </svg>
  );
};

export default CalendarAltIcon;
